




















import { defineComponent, computed } from "@nuxtjs/composition-api";
export default defineComponent({
  name: "CmsBanner",
  props: {
    bannerData: {
      type: Object,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      default: () => {},
    },
  },
  setup(props) {
    return {
      heroData: computed(() => props.bannerData),
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  created() {},
  mounted() {
    if (document && this.heroData.imgUrl) {
      document.body.classList.add("show-hero-img");
    } else {
      document.body.classList.remove("show-hero-img");
    }
    window.addEventListener("scroll", this.whenScroll);
  },
  updated() {
    if (document.getElementsByClassName("banner").length) {
      document.body.classList.add("show-hero-img");
    }
  },
  methods: {
    whenScroll: function () {
      if (window.scrollY > 0) {
        document.body.classList.remove("show-hero-img");
      } else {
        if (document.getElementsByClassName("banner").length) {
          document.body.classList.add("show-hero-img");
        }
      }
    },
  },
});
